export const MIN_GRAFANA_VERSION = '8.5.0';
